import { Checkbox, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import dashboardStyles from './../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss';
import whatsAppCampaignStyles from "../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignAnalysisStyle.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import feedbackStyles from "../../../assets/styles/componentStyles/feedbackStyles/feedbackStyle.module.scss";
import contactStyles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext';
import { campaignContactAssignmentData, createCampaignResponse } from '../../../models/axiosModel';
import { formatDateAccordingToTimezoneUsingMoment } from '../../../utils/constants';
import { primaryColor } from '../../../utils/colors';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import InfoIcon from '@mui/icons-material/Info';
import styles from '../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisAudio.module.scss'
import IconsColor from '../../utility/iconsColor';
import { makeStyles } from '@mui/styles';
import subChatbotStyle from './../../../assets/styles/componentStyles/subChatbotStyles/subChatbot.module.scss'
import GlobalButton from '../../utility/globalButton/button';

interface contactsInterface {
    tableData: createCampaignResponse | null,
    statusColor: (executionStatus?: string, flagLightColor?: boolean) => string | undefined,
    contactTagActionData: any;
    onChangeOfFilterStatus: any,
    flagDashboardPage?: boolean,
    setFlagAnalyticsStatus: React.Dispatch<React.SetStateAction<boolean>>
}

const CampaignAnalysisContacts = (props: contactsInterface) => {
    const { setCampaignContactStatusPopup, setCurrentContactStatus } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;
    const { userDetail, setFlagLoading } = useContext(UserContext) as UserContextPayload;
    const { statusColor, contactTagActionData, onChangeOfFilterStatus, tableData, flagDashboardPage, setFlagAnalyticsStatus } = props;

    const [page, setPage] = useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = useState<number>(1000);

    const handleClickStatus = (contactStatus: campaignContactAssignmentData) => {
        setCampaignContactStatusPopup(true);
        setCurrentContactStatus(contactStatus)
    }

    const useStyles = makeStyles(() => ({
        customTooltip: {
            backgroundColor: '#FAFAFA',
            color: '#000',
            boxShadow: "0px 0px 2px rgba(0,0,0,0.25)",
            fontSize: '13px',
            padding: '8px 15px',
            borderRadius: 5,
            maxHeight: "400px",
            maxWidth: "400px !important",
            overflow: "auto",
            marginTop: "-10px !important"
        },
        customArrow: {
            color: '#FFF',
            boxShadow: "0px 0px 2px rgba(0,0,0,0.25)",
        },
    }));
    const classes = useStyles();

    useEffect(() => {
        if (tableData && tableData?.campaign_contact_assignment_data?.length > 0) {
            setPage(0);
        }
    }, [tableData])

    const escapeCSVValue = (value: string): string => {
        if (typeof value !== "string") value = String(value);
        if (value.includes('"')) {
            value = value.replace(/"/g, '""');
        }
        if (value.includes(',') || value.includes('\n') || value.includes('"')) {
            value = `"${value}"`;
        }
        return value;
    };

    const switchCaseOfContacts = (header: string, contacts: campaignContactAssignmentData) => {
        switch (header) {
            case "Phone Number":
                return contacts.contact_phone_number || "";
            case "Full Name":
                return contacts.contact_name || "";
            case "Updated At":
                return contacts.updated_at_timestamp ? formatDateAccordingToTimezoneUsingMoment(contacts?.updated_at_timestamp, userDetail.timezone_hour) : "-";
            case "Execution Status":
                return contacts.campaign_execution_tracking_status ? contacts.campaign_execution_tracking_status : contacts.campaign_execution_status_name;
            case "Analytics Status":
                let Clicked = contacts?.campaign_analytics_status?.find((status) => status.campaign_execution_status_name?.toLowerCase() == "clicked")?.campaign_execution_status_name
                let Replied = contacts?.campaign_analytics_status?.find((status) => status.campaign_execution_status_name?.toLowerCase() == "replied")?.campaign_execution_status_name
                let value = [""];
                if (!Clicked && !Replied) {
                    value = ["NA"];
                }
                else if (Clicked && Replied) {
                    value = [Clicked, Replied];
                }
                else if (Clicked) {
                    value = [Clicked]
                }
                else if (Replied) {
                    value = [Replied]
                }
                return value.join(" & ");
            case "Failure Reason":
                return contacts.campaign_execution_status_name.toLowerCase() == "failed" ? contacts?.failure_reason ? contacts?.failure_reason : contacts?.campaign_execution_tracking_data?.find((trackData) => trackData?.message_status?.toLowerCase() == "failed")?.error_obj ? JSON.parse(contacts?.campaign_execution_tracking_data?.find((trackData) => trackData?.message_status?.toLowerCase() == "failed")?.error_obj || "")?.[0]?.error_data?.details : "-" : "-";
            default:
                return "";
        }
    }

    const downloadContactsCSV = (flagSelected?: boolean) => {
        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: true }));
        const headers = ['Phone Number', 'Full Name', 'Updated At', 'Execution Status', 'Analytics Status', 'Failure Reason'];
        let rows: string[][] = [[]];

        if (flagSelected) {
            if (contactTagActionData?.preSelectedContacts && contactTagActionData?.preSelectedContacts?.length > 0) {
                rows = contactTagActionData?.preSelectedContacts?.sort((a: campaignContactAssignmentData, b: campaignContactAssignmentData) => (a.updated_at_timestamp ? Number(a.updated_at_timestamp) : Number(a.created_at_timestamp)) - (b.updated_at_timestamp ? Number(b.updated_at_timestamp) : Number(b.created_at_timestamp)))?.map((tabData: any) => {
                    const row: string[] = [];
                    headers.forEach(header => {
                        row.push(switchCaseOfContacts(header, tabData))
                    })
                    return row
                })
            }
        }
        else {
            if (tableData && tableData?.campaign_contact_assignment_data && tableData?.campaign_contact_assignment_data?.length > 0) {
                rows = tableData?.campaign_contact_assignment_data?.sort((a: campaignContactAssignmentData, b: campaignContactAssignmentData) => (a.updated_at_timestamp ? Number(a.updated_at_timestamp) : Number(a.created_at_timestamp)) - (b.updated_at_timestamp ? Number(b.updated_at_timestamp) : Number(b.created_at_timestamp)))?.map((tabData) => {
                    const row: string[] = [];
                    headers.forEach(header => {
                        row.push(switchCaseOfContacts(header, tabData))
                    })
                    return row
                })
            }
        }


        const csvContent = [headers, ...rows]
            .map(row => row.map(cell => escapeCSVValue(cell)).join(","))
            .join("\n");
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `campaign_contacts.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        setFlagLoading(prevState => ({ ...prevState, flagRoundLoader: false }));
    }
    return (
        <Grid container className={`${globalStyles.flexColumn} ${globalStyles.gapTwo}`}>
            <Grid item className={`${globalStyles.fullwidth}`}>
                <TableContainer sx={{ borderRadius: "5px", border: "1px solid #E9E9E9", maxWidth: "100%", overflow: "auto", maxHeight: "450px" }}>
                    <Table aria-label="simple table" stickyHeader>
                        <TableHead>
                            <TableRow>
                                {!flagDashboardPage &&
                                    <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle} ${contactStyles.checkBoxTableCell}`}>
                                        <Checkbox
                                            checked={tableData?.campaign_contact_assignment_data.length == contactTagActionData.preSelectedContacts.length}
                                            onChange={(event) => onChangeOfFilterStatus('manualEdit', event?.target.checked, true)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            className={whatsAppCampaignStyles.filterStatusCheckBox}
                                            // disabled={(filteredCampaignContactData && filteredCampaignContactData.length === 0) ? true : false}
                                            color="secondary"
                                        />
                                    </TableCell>
                                }
                                <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle} ${flagDashboardPage && contactStyles.checkBoxTableCell}`}>Phone Number</TableCell>
                                <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Full Name</TableCell>
                                <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Updated At</TableCell>
                                <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Execution Status</TableCell>
                                <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Analytics Status</TableCell>
                                {flagDashboardPage &&
                                    <>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>
                                            Campaign
                                        </TableCell>
                                        <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>
                                            Contact List
                                        </TableCell>
                                    </>
                                }
                                <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Failure Reason</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData ? tableData?.campaign_contact_assignment_data
                                ?.sort((a: campaignContactAssignmentData, b: campaignContactAssignmentData) => {
                                    const aChecked = contactTagActionData.preSelectedContacts.some(
                                        (selectedContact: any) => selectedContact.contact_id === a.contact_id
                                    );
                                    const bChecked = contactTagActionData.preSelectedContacts.some(
                                        (selectedContact: any) => selectedContact.contact_id === b.contact_id
                                    );

                                    const aTime = a.updated_at_timestamp
                                        ? new Date(a.updated_at_timestamp).getTime()
                                        : new Date(a.created_at_timestamp).getTime();
                                    const bTime = b.updated_at_timestamp
                                        ? new Date(b.updated_at_timestamp).getTime()
                                        : new Date(b.created_at_timestamp).getTime();
                                    const anyChecked = contactTagActionData.preSelectedContacts.length > 0;
                                    // ✅ If any contacts are checked, prioritize checked first
                                    if (anyChecked) {
                                        if (aChecked !== bChecked) return aChecked ? -1 : 1;
                                    }

                                    // ✅ Otherwise, just sort by timestamp
                                    return bTime - aTime;
                                })
                                .slice((page * rowsPerPage), (page * rowsPerPage) + rowsPerPage).map((contacts: campaignContactAssignmentData, ind: number) =>
                                    <Tooltip title={contacts.flag_deleted ? "This Contact has been deleted." : ""} placement='top-start'>
                                        <TableRow key={ind} className={dashboardStyles.cellRow}>
                                            {!flagDashboardPage &&
                                                <TableCell
                                                    className={dashboardStyles.tableBodySubHeadingFontStyle}
                                                    sx={{
                                                        borderLeft: contacts.flag_deleted ? '4px solid #CF2C2C' : '4px solid transparent',
                                                        borderTopLeftRadius: contacts.flag_deleted ? "10%" : "0",
                                                        borderBottomLeftRadius: contacts.flag_deleted ? "10%" : "0"
                                                    }}
                                                >
                                                    <Checkbox
                                                        checked={contactTagActionData.preSelectedContacts.some((selectedContact: any) => selectedContact.contact_id == contacts.contact_id)}
                                                        onChange={(event) => onChangeOfFilterStatus('manualEdit', event?.target.checked, false, contacts)}
                                                        inputProps={{ 'aria-label': 'controlled' }}
                                                        color="secondary"
                                                        disabled={contacts.flag_deleted}
                                                        className={whatsAppCampaignStyles.filterStatusCheckBox}
                                                    />
                                                </TableCell>
                                            }
                                            <TableCell
                                                className={dashboardStyles.tableBodySubHeadingFontStyle}
                                                sx={{
                                                    borderLeft: flagDashboardPage ? contacts.flag_deleted ? '4px solid #CF2C2C' : '4px solid transparent' : "none",
                                                    borderTopLeftRadius: (flagDashboardPage && contacts.flag_deleted) ? "5%" : "0",
                                                    borderBottomLeftRadius: (flagDashboardPage && contacts.flag_deleted) ? "5%" : "0"
                                                }}
                                            >
                                                {contacts.contact_phone_number}
                                            </TableCell>
                                            <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{contacts.contact_name ? contacts.contact_name : "-"}</TableCell>
                                            <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{contacts.updated_at_timestamp ? formatDateAccordingToTimezoneUsingMoment(contacts?.updated_at_timestamp, userDetail.timezone_hour) : "-"}</TableCell>
                                            <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                <span
                                                    style={{
                                                        padding: "2px 15px 4px",
                                                        borderRadius: "5px",
                                                        boxShadow: `0px 0px 2px ${statusColor(contacts.campaign_execution_tracking_status ? contacts.campaign_execution_tracking_status : contacts.campaign_execution_status_name)}`,
                                                        backgroundColor: statusColor(contacts.campaign_execution_tracking_status ? contacts.campaign_execution_tracking_status : contacts.campaign_execution_status_name, true),
                                                        color: statusColor(contacts.campaign_execution_tracking_status ? contacts.campaign_execution_tracking_status : contacts.campaign_execution_status_name),
                                                        textTransform: "capitalize",
                                                        fontSize: "12px"
                                                    }}
                                                >
                                                    {contacts.campaign_execution_tracking_status ? contacts.campaign_execution_tracking_status : contacts.campaign_execution_status_name}
                                                </span>
                                                <span style={{ margin: "8px", verticalAlign: "sub", cursor: "pointer" }} onClick={() => handleClickStatus(contacts)}>
                                                    <IconsColor iconName="info" fillColor={primaryColor} height="16" width="16" />
                                                </span>
                                            </TableCell>
                                            <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                {/* {contacts.campaign_execution_tracking_status == "Clicked" ? contacts?.cam?.filter((track) => track.tracking_count > 0)?.length : "NA"} */}
                                                {contacts?.campaign_analytics_status?.find((status) => status.campaign_execution_status_name?.toLowerCase() == "clicked") &&
                                                    <>
                                                        <span
                                                            style={{
                                                                padding: "2px 15px 4px",
                                                                borderRadius: "5px",
                                                                boxShadow: `0px 0px 2px ${statusColor("clicked")}`,
                                                                backgroundColor: statusColor("clicked", true),
                                                                color: statusColor("clicked"),
                                                                textTransform: "capitalize",
                                                                fontSize: "12px", marginRight: "10px"
                                                            }}
                                                        >
                                                            Clicked
                                                        </span>
                                                    </>
                                                }
                                                {contacts?.campaign_analytics_status?.find((status) => status.campaign_execution_status_name?.toLowerCase() == "replied") &&
                                                    <span
                                                        style={{
                                                            padding: "2px 15px 4px",
                                                            borderRadius: "5px",
                                                            boxShadow: `0px 0px 2px ${statusColor("replied")}`,
                                                            backgroundColor: statusColor("replied", true),
                                                            color: statusColor("replied"),
                                                            textTransform: "capitalize",
                                                            fontSize: "12px"
                                                        }}
                                                    >
                                                        Replied
                                                    </span>
                                                }
                                                {(contacts?.campaign_analytics_status?.find((status) => status.campaign_execution_status_name?.toLowerCase() == "clicked")
                                                    || contacts?.campaign_analytics_status?.find((status) => status.campaign_execution_status_name?.toLowerCase() == "replied")) && !flagDashboardPage &&
                                                    <span style={{ margin: "8px", verticalAlign: "sub", cursor: "pointer" }} onClick={() => { handleClickStatus(contacts); setFlagAnalyticsStatus(true) }}>
                                                        <IconsColor iconName="info" fillColor={primaryColor} height="16" width="16" />
                                                    </span>
                                                }
                                                {!contacts?.campaign_analytics_status?.find((status) => status.campaign_execution_status_name?.toLowerCase() == "clicked")
                                                    && !contacts?.campaign_analytics_status?.find((status) => status.campaign_execution_status_name?.toLowerCase() == "replied") &&
                                                    <span>NA</span>
                                                }
                                            </TableCell>
                                            {flagDashboardPage &&
                                                <>
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                        <a className={`${whatsAppCampaignStyles.redirectingText}`} href={`${window.location.origin}/whatsappcampaign?campaign_id=${contacts.campaign_id}`} target='_blank'>
                                                            {contacts.campaign_title}
                                                        </a>
                                                    </TableCell>
                                                    <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                        {contacts.contact_list_name ?
                                                            <a className={`${whatsAppCampaignStyles.redirectingText}`} href={`${window.location.origin}/contacts?contact_list_id=${contacts.contact_list_id}`} target='_blank'>
                                                                {contacts.contact_list_name}
                                                            </a>
                                                            : "-"
                                                        }
                                                    </TableCell>
                                                </>
                                            }
                                            {/* <Tooltip
                                            title={contacts.campaign_execution_status_name.toLowerCase() == "failed" ? contacts?.failure_reason : contacts?.campaign_execution_tracking_data?.find((trackData) => trackData?.message_status?.toLowerCase() == "failed")?.error_obj || ""}
                                            classes={{ tooltip: classes.customTooltip, arrow: classes.customArrow }} 
                                            className={subChatbotStyle.toolTipStyle}
                                            placement='bottom-start'
                                        > */}
                                            <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle}`}>
                                                {contacts.campaign_execution_status_name.toLowerCase() == "failed" ? contacts?.failure_reason ? contacts?.failure_reason : contacts?.campaign_execution_tracking_data?.find((trackData) => trackData?.message_status?.toLowerCase() == "failed")?.error_obj ? JSON.parse(contacts?.campaign_execution_tracking_data?.find((trackData) => trackData?.message_status?.toLowerCase() == "failed")?.error_obj || "")?.[0]?.error_data?.details : "-" : "-"}
                                            </TableCell>
                                            {/* </Tooltip> */}
                                        </TableRow>
                                    </Tooltip>
                                )
                                :
                                <TableRow className={dashboardStyles.cellRow}>
                                    <TableCell colSpan={12} sx={{ textAlign: "center" }}>
                                        No Data Available
                                    </TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            {(tableData && tableData?.campaign_contact_assignment_data?.length > 0) &&
                <Grid item className={globalStyles.textItemsEnd} >
                    <Grid container className={globalStyles.contentEnd} gap={1} alignItems={"center"}>
                        <Grid item>
                            <GlobalButton
                                buttonText="Export All Contacts"
                                onClick={() =>
                                    downloadContactsCSV()
                                }
                                className='primaryButtonStyle'
                            />
                        </Grid>
                        {contactTagActionData?.preSelectedContacts?.length > 0 &&
                            <Grid item>
                                <GlobalButton
                                    buttonText="Export Selected Contacts"
                                    onClick={() =>
                                        downloadContactsCSV(true)
                                    }
                                    className='primaryButtonStyle'
                                />
                            </Grid>
                        }
                        <Grid item sx={{ padding: "0 8px 0 8px", boxShadow: "0 0 2px rgba(0,0,0,0.5)", borderRadius: "5px", margin: "0 2px 5px 2px" }}>
                            <TablePagination
                                component="div"
                                className={`${feedbackStyles.feedbackTablePaginationStyle}`}
                                count={tableData?.campaign_contact_assignment_data?.length}
                                rowsPerPageOptions={[10, 25, 50, 100, 1000]}
                                labelRowsPerPage="Rows per page:"
                                page={page}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value))}
                                onPageChange={(e, newPage) => setPage(newPage)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            }
        </Grid>
    )
}

export default CampaignAnalysisContacts
